<template>
  <div
    id="modal_showApp"
    class="modal fade"
  >
    <div
      class="modal-dialog modal-full"
      style="max-width:1000px"
    >
      <div class="modal-content">
        <div class="modal-header">
            <button
            type="button"
            class="close"
            @click="closeModal('modal_showApp')"
            style="background: transparent; border: none; font-size: 2rem; color: #000000FF; outline: none; cursor: pointer;"
            aria-label="Close"
            title="Close"
            >
            <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
            </button>
          <!-- check if you are in approved order page then show this purchase button -->
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close"
            @click.prevent="$emit('open-purchase-modal', detialData)"
            style="position: none; margin-right: 115px;color: rgb(46, 125, 50);"
          >
          <i class="material-icons" style="vertical-align: middle; margin-right: 8px;">add_shopping_cart</i>
          </button>
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close"
            @click.prevent="$emit('open-refund-modal', detialData)"
            style="position: none; margin-right: 75px;    color: rgb(198, 40, 40);"
          >
          <i class="material-icons" style="vertical-align: middle; margin-right: 8px;">block</i>
          </button>
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close"
            @click.prevent="$emit('open-partial-refund-modal', detialData)"
            style="position: none; margin-right: 40px;color: rgb(255, 87, 34);"
          >
          <i class="fa fa-registered" style="vertical-align: middle; margin-right: 8px;"></i>
          </button>
          <h3 class="modal-title">View Order Details</h3>
        </div>

        <div class="modal-body">
          <order-images
            v-if="detialData.order_id"
            :formData="detialData"
          />
          <!-- <div
            class="row"
            v-if="detialData.images && detialData.images.length > 0"
          >
            <div
              class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4"
              v-for="(img,i) in detialData.images"
              :key="i"
              style="cursor: pointer"
              @click="showImage(img)"
            >
              <img
                :src="img.order_image && img.order_image.startsWith('http') ? img.order_image : `${$_image_path()}${img.order_image}`"
                alt="Image"
                width="100%"
                height="150px"
                style="border-radius: 4px"
              >
            </div>
          </div> -->

          <!-- <div
            v-if="detialData.order_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Order Branch: </strong>{{ detialData.order_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.approve_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Approve Branch: </strong>{{ detialData.approve_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.deliver_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Deliver Branch: </strong>{{ detialData.deliver_branch_name }}</h5>
          </div> -->

          <div class="col-sm-6">
            <h5><strong>Customer: </strong>{{ detialData.full_name }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Email: </strong> {{ detialData.email }}</h5>
          </div>
          <div class="col-sm-12">
            <h5><strong>Customer Note: </strong>{{ detialData.customer_note }}</h5>
          </div>

          <div class="col-sm-6">
            <h5><strong>Phone Number: </strong> {{ detialData.phone_number }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Order ID: </strong> {{ detialData.theOrderID }}</h5>
          </div>
          <!--<div class="col-sm-6"> -->
          <!--<h5 v-if="detialData.c_o_d == '1'"> <strong>Cash on Deliver: </strong> Yes</h5> -->
          <!--<h5 v-else> <strong>Cash on Deliver: </strong> No</h5> -->
          <!--</div>-->

          <div class="col-sm-6">
            <h5>
              <strong>Product url: </strong>
              <a
                :href="detialData.product_url"
                target="_blank"
              >{{
                  detialData.product_url ? detialData.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (detialData.product_url.length > 25 ? '...' : '') : detialData.product_url
                }}
              </a>
            </h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Product Name : </strong> {{ detialData.product_name }}</h5>
          </div>
          <div
            v-if="detialData.process_note"
            class="col-sm-6"
          >
            <h5><strong>Admin Process note : </strong> {{ detialData.process_note }}</h5>
          </div>
          <div
            v-if="detialData.customer_process_note"
            class="col-sm-6"
          >
            <h5><strong>Customer Process note : </strong> {{ detialData.customer_process_note }}</h5>
          </div>
          <div
            v-if="detialData.customer_process_note_image"
            class="col-sm-6"
          >
            <img
              :src="`${$_image_path()}${detialData.customer_process_note_image}`"
              alt="Preview"
              style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
            />
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.size"
          >
            <h5><strong>Size: </strong>{{ detialData.size }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.type"
          >
            <h5><strong>Type: </strong>{{ detialData.type }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Status : </strong>{{ detialData.status }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.color"
          >
            <h5><strong>Color: </strong>{{ detialData.color }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Quantity: </strong>{{ detialData.quantity }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.coupon"
          >
            <h5><strong>Coupon: </strong>{{ detialData.coupon }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.coupon"
          >
            <h5><strong>Coupon Percentage: </strong>{{ detialData.coupon_percentage }}%</h5>
          </div>
          <div class="col-sm-6">
            <h5 v-if="detialData.delivery_type == 'office delivery'">
              <strong>Delivery Type: </strong>
              <span
                class="fa fa-building"
                style="color: teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
            <h5 v-else>
              <strong>Delivery Type: </strong>
              <span
                class="glyphicon glyphicon-home "
                style="color:teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
          </div>

          <div class="col-sm-6">
            <h5 style="color: #ff5252"><strong>Transportation Type: </strong>{{ detialData.transportation_type_obj ? detialData.transportation_type_obj.name : '' }}</h5>
          </div>

          <div class="col-sm-6">
            <div class="d-flex mt-3">
              <div>
                <i
                  v-if="detialData.is_repackage"
                  class="fa fa-check-square text-primary"
                  style="font-size: 18px;"
                />
                <i
                  v-else
                  class="fa fa-square-o"
                  style="font-size: 18px"
                />
                <span
                  class="ml-2"
                  style="font-size: 15px;"
                >Repackage</span>
              </div>

              <div>
                <i
                  v-if="detialData.is_hold"
                  class="fa fa-check-square text-primary"
                  style="font-size: 18px;"
                />
                <i
                  v-else
                  class="fa fa-square-o"
                  style="font-size: 18px"
                />
                <span
                  class="ml-2"
                  style="font-size: 15px;"
                >Hold</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <h5><strong>Other service: </strong> {{ detialData.other_service }}</h5>
          </div>

          <div
            v-if="detialData.repackage_price"
            class="col-sm-6"
          >
            <h5><strong>Repackage Price: </strong> ${{ detialData.repackage_price }}</h5>
          </div>

          <div
            v-if="detialData.hold_price"
            class="col-sm-6"
          >
            <h5><strong>Hold Price: </strong> ${{ detialData.hold_price }}</h5>
          </div>

          <div
            v-if="detialData.other_service_price"
            class="col-sm-6"
          >
            <h5><strong>Other Service Price: </strong> ${{ detialData.other_service_price }}</h5>
          </div>

          <div
            v-if="detialData.handling_fee"
            class="col-sm-6"
          >
            <h5><strong>Handling Fee: </strong> ${{ detialData.handling_fee }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.bank_name"
          >
            <h5 v-if="!bankEditing">
              <strong>Bank name: </strong> {{ detialData.bank_name }}
              <a
                v-if="$_has_perm('purchase_approved_order')"
                href="#"
                title="Change bank"
                style="margin-left: 6px;"
                @click.prevent="startBankEdit"
              ><i class="material-icons" style="font-size: 18px; vertical-align: middle;">edit</i></a>
            </h5>
            <div v-else style="display: flex; align-items: center; gap: 8px;">
              <strong>Bank name: </strong>
              <select v-model="newBankId" class="form-control" style="max-width: 220px;">
                <option v-for="b in banks" :key="b.bank_id" :value="b.bank_id">{{ b.bank_name }}</option>
              </select>
              <button type="button" class="btn btn-success btn-sm" :disabled="!newBankId || bankSaving" @click="saveBank">Save</button>
              <button type="button" class="btn btn-default btn-sm" :disabled="bankSaving" @click="bankEditing = false">Cancel</button>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.cancel_reason"
          >
            <h5><strong>Cancel reason: </strong> {{ detialData.cancel_reason }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.quantity_charge"
          >
            <h5><strong>Quantity charge: </strong>${{ detialData.quantity_charge }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.the_tl_price"
          >
            <h5><strong>Item Price TL: </strong>tl {{ detialData.the_tl_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.item_price"
          >
            <h5><strong>Item Price USD: </strong>${{ detialData.item_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.tax"
          >
            <h5><strong>Tax: </strong>${{ detialData.tax }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.national_tax"
          >
            <h5><strong>International Tax: </strong>${{ detialData.national_tax }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.item_weight"
          >
            <h5><strong>Item Weight: </strong>{{ detialData.item_weight }} KG / {{ (detialData.item_weight / 0.4545).toFixed(2) }} LB</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.volume"
          >
            <h5><strong>Volume: </strong>{{ detialData.volume }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.internal_shipping_handling"
          >
            <h5><strong>Int Shipping: </strong>${{ detialData.internal_shipping_handling }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.kreenex_fee"
          >
            <h5><strong>ShipZone Fee: </strong>${{ detialData.kreenex_fee }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.insurance"
          >
            <h5><strong>Insurance: </strong>${{ detialData.insurance }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.delivery_price"
          >
            <h5><strong>Delivery Price: </strong>${{ detialData.delivery_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.local_delivery"
          >
            <h5><strong>Local Delivery: </strong>${{ detialData.local_delivery }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.price_weight"
          >
            <h5><strong>Processed At Price Weight: </strong>${{ detialData.price_weight }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.item_type"
          >
            <h5><strong>Item Type: </strong>{{ detialData.item_type }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.discount"
          >
            <h5><strong>Discount: </strong>{{ detialData.discount }}</h5>
          </div>
          <div
            class="col-sm-6"
          >

          </div>
          <div
            class="col-sm-6 red--text"
            v-if="detialData.status == 'refunded'"
          >
            <h5><strong>Refund Amount: </strong>{{ detialData.money_amount | usdFormat }}</h5>
          </div>

          <div class="col-sm-6">
            <h5>
              <strong>Warehouse: </strong>
              <span v-if="detialData.country == 'USA'">
                <flag iso="um" />
              </span>
              <span v-else-if="detialData.country == 'Turkey'">
                <flag iso="tr" />
              </span>
              <span v-else-if="detialData.country == 'China'">
                <flag iso="cn" />
              </span>
              <span v-else-if="detialData.country == 'German'">
                <flag iso="de" />
              </span>
              <span v-else-if="detialData.country == 'UK'">
                <flag iso="gb" />
              </span>
              &nbsp; {{ detialData.country }}
            </h5>
          </div>

          <div
            v-if="detialData.track_number"
            class="col-sm-6"
          >
            <h5><strong>Track number: </strong> {{ detialData.track_number }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.barcode"
          >
            <h5><strong>Order Number: </strong> {{ detialData.barcode }}</h5>
          </div>
          <div
            class="col-sm-6 col-md-6"
            v-if="detialData.qrcode"
          >
            <div class="col-xs-4 col-sm-4 col-md-3">
              <h5><strong>QrCode:</strong></h5>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <qr-code
                :text="detialData.order_id.toString()"
                :size="size"
              ></qr-code>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.description"
          >
            <h5><strong>Description : </strong>{{ detialData.description }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.refund_reason"
          >
            <h5><strong>Refund Reason: </strong>{{ detialData.refund_reason }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.note"
          >
            <h5><strong>Note: </strong>{{ detialData.note }}</h5>
          </div>

          <div class="col-sm-12" style="margin-top: 5px;">
            <div class="row">
              <div
                v-if="detialData.partial_refunds && detialData.partial_refunds.length"
                class="col-sm-6"
              >
                <h5><strong>Partial Refunds</strong></h5>
                <ol>
                  <li
                    v-for="pr in detialData.partial_refunds"
                    :key="pr.partial_refund_id"
                    style="font-size: 14px"
                    class="mb-1"
                  >
                    <div class="ml-2">
                      Amount: ${{ pr.amount }}
                      <span class="ml-2 text--secondary">at {{ pr.created_at | moment('YYYY-MM-DD hh:mm a') }}</span>
                      <span class="ml-2 text--secondary">by {{ pr.user.full_name }}</span>
                    </div>
                    <div class="ml-2">{{ pr.note }}</div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div class="col-sm-12" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
            <div class="col-sm-6">
              <h5><strong>Order Date: </strong>{{ detialData.order_date }}</h5>
            </div>
            <div
            class="col-sm-6"
            v-if="detialData.confirm_date"
          >
            <h5><strong>Confirm Date: </strong> {{ detialData.confirm_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.warehouse_date"
          >
            <h5><strong>Warehouse Date: </strong>{{ detialData.warehouse_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="palletNumber"
          >
            <h5><strong>Pallet / Plane No: </strong>{{ palletNumber }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.from_date"
          >
            <h5><strong>From Date: </strong>{{ detialData.from_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.to_date"
          >
            <h5><strong>To Date: </strong>{{ detialData.to_date }}</h5>
          </div>
          </div>

          <div class="col-sm-12" style="background-color: #f5d7a8;border:1px solid #bbb; border-radius: 5px;">
            <div class="col-sm-4">
              <h5><strong>Purchase cost: </strong>{{ detialData.item_price * detialData.quantity + detialData.national_tax + detialData.delivery_price | usdFormat }}</h5>
            </div>
            <div class="col-sm-4">
              <h5><strong>Actual cost: </strong>{{ detialData.actual_price | usdFormat }}</h5>
            </div>
            <div class="col-sm-4">
              <h5><strong>Total Amount: </strong>{{ detialData.total_amount | usdFormat }}</h5>
            </div>

          </div>

        </div>

        <div class="modal-footer"></div>
      </div>
    </div>

    <!-- <v-dialog
      v-model="imageDialog"
      width="500"
    >
      <v-card>
        <img
          :src="`${$_image_path()}${theImg}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['detialData', 'closeModal'],

  data() {
    return {
      imageDialog: false,
      theImg: '',
      size: 50,
      palletNumber: '',
      bankEditing: false,
      bankSaving: false,
      banks: [],
      newBankId: null
    }
  },

  watch: {
    // The pallet is asked for separately, and only for admins who may see the pallet report.
    'detialData.order_id': {
      immediate: true,
      handler(orderId) {
        this.palletNumber = ''
        this.bankEditing = false
        if (!orderId || !this.$_has_perm('view_pallet_report')) {
          return
        }

        axios
          .get('api/pallets/order/' + orderId, {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
          })
          .then((response) => {
            if (this.detialData && this.detialData.order_id === orderId) {
              this.palletNumber = response.data.tracking_number || ''
            }
          })
          .catch(() => { })
      }
    }
  },

  methods: {
    startBankEdit() {
      const current = this.banks.find((b) => b.bank_name === this.detialData.bank_name)
      this.newBankId = current ? current.bank_id : null
      this.bankEditing = true
      if (this.banks.length) {
        return
      }
      axios
        .get('api/get_banks', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
        })
        .then((response) => {
          this.banks = response.data.data
          const found = this.banks.find((b) => b.bank_name === this.detialData.bank_name)
          this.newBankId = found ? found.bank_id : null
        })
    },

    saveBank() {
      this.bankSaving = true
      axios
        .post('api/change-order-bank', { order_id: this.detialData.order_id, bank_id: this.newBankId }, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
        })
        .then(() => {
          const bank = this.banks.find((b) => b.bank_id === this.newBankId)
          this.detialData.bank_name = bank.bank_name
          this.bankEditing = false
        })
        .catch(() => {
          alert('Could not change the bank')
        })
        .finally(() => {
          this.bankSaving = false
        })
    },

    showImage(img) {
      this.theImg = img.order_image
      this.imageDialog = true
    }
  }
}
</script>

<style>
.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDetails.vue